var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@web/components/layout/Button';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { widgetMetricTableFigureValueSpanHugClass, widgetMetricTablePairHeaderThAlignBodyTdClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerFitClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTableStackedDiffsRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { getDemoActivityLabelIdByName } from '@web/lib/demo/data/labels';
import { trpc } from '@web/lib/trpc';
import { classNames, getIconByType, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { DRIVE_EXTERNAL_SHARE_SEARCH, navigateToDriveAdvancedSearch } from '@web/utility/chartNavigation';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ActivityLabelTargetEnum, DocumentTypeEnum } from '@workalizer/shared';
import { UNCATEGORIZED_LABEL_NAME, WIDGET_TABLE_INITIAL_ROWS, WIDGET_TABLE_LOAD_MORE_ROWS } from '@workalizer/shared/config';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { sliceRowsKeepingUncategorizedLast, uncategorizedLast } from '@workalizer/shared/utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
function docsSharedExternallyByLabelTableColgroup() {
    var metricPair = [
        { width: '4%', minWidth: '2.75rem' },
        { width: '6%', minWidth: '5.5rem' }
    ];
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
        { width: '20%', minWidth: '10.5rem' }
    ], metricPair, true), metricPair, true), metricPair, true), metricPair, true), metricPair, true);
}
var metricHeaderColspan = 2;
var headerMetricClass = widgetMetricTablePairHeaderThAlignBodyTdClass;
export var DocsSharedExternallyByLabel = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo, _b = _a.isSecondaryDiffHidden, isSecondaryDiffHidden = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _c = useWorkspaceCtx(), allLabels = _c.labels, isWorkspaceLoading = _c.isLoading;
    var labelsForDisplay = allLabels.filter(function (label) {
        return label.rules.some(function (rule) {
            return rule.target === ActivityLabelTargetEnum.DOCUMENT_TITLES ||
                rule.target === ActivityLabelTargetEnum.ALL;
        });
    });
    var _d = useState(WIDGET_TABLE_INITIAL_ROWS), displayedCount = _d[0], setDisplayedCount = _d[1];
    var _e = trpc.docsSharedExternallyByLabel.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        labelIds: labelsForDisplay.map(function (label) { return label.id; })
    }, { enabled: !isWorkspaceLoading }), data = _e.data, isLoading = _e.isLoading, refetch = _e.refetch;
    var showTeamDiff = Boolean(userId);
    var columns = [
        {
            title: t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.label'),
            isVisible: true,
            className: 'min-w-[10.5rem] sm:min-w-0 !text-left !pl-3 !pr-4 whitespace-normal'
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [getIconByType(DocumentTypeEnum.DOCUMENT, {
                        width: '20',
                        height: '20'
                    }), _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.documents') })] }))),
            isVisible: true,
            className: headerMetricClass,
            colspan: metricHeaderColspan
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [getIconByType(DocumentTypeEnum.SPREADSHEET, {
                        width: '20',
                        height: '20'
                    }), _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.spreadsheets') })] }))),
            isVisible: true,
            className: headerMetricClass,
            colspan: metricHeaderColspan
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [getIconByType(DocumentTypeEnum.PRESENTATION, {
                        width: '20',
                        height: '20'
                    }), _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.presentation') })] }))),
            isVisible: true,
            className: headerMetricClass,
            colspan: metricHeaderColspan
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [getIconByType(DocumentTypeEnum.PDF, { width: '20', height: '20' }), _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.pdf') })] }))),
            isVisible: true,
            className: headerMetricClass,
            colspan: metricHeaderColspan
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [getIconByType(DocumentTypeEnum.OTHER, { width: '20', height: '20' }), _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.other') })] }))),
            isVisible: true,
            className: headerMetricClass,
            colspan: metricHeaderColspan
        }
    ];
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var navigationScope = {
        navigateTo: navigateTo,
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnitId
    };
    var resolveActivityLabelId = function (labelName) {
        var _a, _b;
        return (_b = (_a = labelsForDisplay.find(function (label) { return label.name === labelName; })) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : getDemoActivityLabelIdByName(labelName);
    };
    var navigateToExternalShareSearch = function (labelName, documentType) {
        navigateToDriveAdvancedSearch(navigationScope, __assign(__assign({}, DRIVE_EXTERNAL_SHARE_SEARCH), { driveSearchType: documentType !== null && documentType !== void 0 ? documentType : null, activityLabelId: resolveActivityLabelId(labelName) }));
    };
    var clickableValueCell = function (id, value, onClick) { return ({
        id: id,
        className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
        render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerFitClass, 'cursor-pointer'), onClick: onClick }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanHugClass }, { children: value })) }))); }
    }); };
    var isUncategorized = function (row) {
        return row.labelName === UNCATEGORIZED_LABEL_NAME;
    };
    var orderedRows = uncategorizedLast(data, isUncategorized);
    var _f = sliceRowsKeepingUncategorizedLast(orderedRows, displayedCount, isUncategorized), displayedRows = _f.displayedRows, hasMore = _f.hasMore;
    var tableData = displayedRows.map(function (item) {
        var rk = item.labelName;
        var labelDisplayName = isUncategorized(item)
            ? t('app.performanceReview.employeePerformanceReview.uncategorized')
            : item.labelName;
        var metricCells = [
            { columnId: 'documents', documentType: DocumentTypeEnum.DOCUMENT },
            {
                columnId: 'spreadsheets',
                documentType: DocumentTypeEnum.SPREADSHEET
            },
            {
                columnId: 'presentations',
                documentType: DocumentTypeEnum.PRESENTATION
            },
            { columnId: 'pdfs', documentType: DocumentTypeEnum.OTHER },
            { columnId: 'other', documentType: DocumentTypeEnum.OTHER }
        ].flatMap(function (_a) {
            var _b;
            var columnId = _a.columnId, documentType = _a.documentType;
            var value = item[columnId];
            var previousDiff = item.previousPeriod[columnId];
            var teamDiff = (_b = item.teamAverage) === null || _b === void 0 ? void 0 : _b[columnId];
            return [
                clickableValueCell("".concat(columnId, "-value-").concat(rk), value, function () {
                    return navigateToExternalShareSearch(item.labelName, documentType);
                }),
                metricTableStackedDiffsRowCell("".concat(columnId, "-diff-").concat(rk), previousDiff, teamDiff, showTeamDiff, isSecondaryDiffHidden)
            ];
        });
        return __spreadArray([
            {
                id: "label-".concat(rk),
                className: classNames(widgetMetricTablePrimaryLabelTdClass, 'min-w-[10.5rem] sm:min-w-0 whitespace-normal !pr-4 cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: "w-full min-w-[9rem] cursor-pointer font-medium break-words sm:min-w-0", onClick: function () { return navigateToExternalShareSearch(item.labelName); } }, { children: labelDisplayName }))); }
            }
        ], metricCells, true);
    });
    return (_jsxs("div", __assign({ className: "w-full min-w-0" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.policyComplianceSection.sharedExternallyByLabel'), description: t('widgetTitleDescriptions.policyCompliance.sharedExternallyByLabel'), insightType: InsightTypeEnum.docsSharedExternallyByLabel, insightsData: orderedRows, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.policyComplianceSection.sharedExternallyByLabel'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, orderedRows.map(function (item) {
                                    var _a;
                                    var labelName = isUncategorized(item)
                                        ? t('app.performanceReview.employeePerformanceReview.uncategorized')
                                        : item.labelName;
                                    return _a = {},
                                        _a[t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.label')] = labelName,
                                        _a[t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.documents')] = item.documents,
                                        _a[t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.spreadsheets')] = item.spreadsheets,
                                        _a[t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.presentation')] = item.presentations,
                                        _a[t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.pdf')] = item.pdfs,
                                        _a[t('app.performanceReview.employeePerformanceReview.policyComplianceSection.tablesData.other')] = item.other,
                                        _a;
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(orderedRows) }) }), _jsx(Table, { columns: columns, data: isInsightsDataEmpty(orderedRows) ? [] : tableData, columnColStyles: docsSharedExternallyByLabelTableColgroup(), tableClassName: classNames('w-full table-auto', 'min-w-[80rem]'), rowClassName: "[&>td]:!align-middle" }), hasMore && (_jsx("div", __assign({ className: "mt-4 flex justify-center" }, { children: _jsx(Button, __assign({ variant: "link", onClick: function () {
                        return setDisplayedCount(function (prev) { return prev + WIDGET_TABLE_LOAD_MORE_ROWS; });
                    } }, { children: t('loadMore') })) })))] })));
};
